import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import axios from 'axios';
import { Grid } from '@material-ui/core';
// app
import { Auth as AuthEntity } from '../../../../entities/auth';
import { Message, MessageTypes, APIUrl } from '../../../../entities/site';
import { openSnackbar, closeSnackbar } from '../../../../store/action-creators';
import { colors } from '../../../../config/styles';
// containers
import RowContainer from '../../../../containers/Row';
// components
import SelectInput, { SelectItem } from '../../../../components/inputs/SelectInput';
import ActionButton from '../../../../components/buttons/ActionButton';
import AddCampaign from '../../../../components/campaign/AddCampaign';
// entities
import { Campaign, emptyCampaign, campaignStatusList } from '../../../../entities/site';
// services
import AuthService from '../../../../services/auth';
// containter
import Loader from '../../../../containers/Loader';
import Modal from '../../../../containers/Modal';

const styles: any = {
  link: {
    color: colors.blue,
    cursor: 'pointer'
  },
  footer: {
    textAlign: 'center',
    fontSize: 12
  }
}

interface EditCampaignProps {
  open: any;
  campaignId: string;
  auth: AuthEntity;
  onClose(route?: string): void
  openSnackbar(message: string): void;
  closeSnackbar(): void;
}

interface EditCampaignState {
  campaign: Campaign;
  loading: boolean;
  message: Message;
  disabled: boolean;
  statuses: SelectItem[];
}

class EditCampaign extends Component<EditCampaignProps, EditCampaignState> {

  constructor(props: EditCampaignProps) {
    super(props);
    this.state = {
      campaign: emptyCampaign,
      loading: false,
      message: {
        message: '',
        messageType: MessageTypes.notification
      },
      disabled: false,
      statuses: campaignStatusList
    }
  }

  componentDidMount = () => {
    if (this.props.campaignId) {
      this.fetchCampaign(this.props.campaignId);
    }
  }

  componentDidUpdate(prevProps: EditCampaignProps, prevState: EditCampaignState) {
    if (prevProps.campaignId !== this.props.campaignId && this.props.campaignId) {
      this.fetchCampaign(this.props.campaignId);
    }
  }

  fetchCampaign = async (campaignId: string) => {
    try {
      this.setState({ 
        loading: true, 
        disabled: true,
        message: {
          message: '',
          messageType: MessageTypes.notification
        }
      });
      const campaignRes = await axios.get(`${AuthService.getApiUrls().site}/campaign/${campaignId}`);
      this.setState({
        loading: false,
        campaign: campaignRes.data,
        disabled: false 
      })      
    } catch(error) {
      this.setState({ loading: false, disabled: false, message: { message: 'Error fetching campaign', messageType: MessageTypes.error } });
    }
  } 

  handleSave = () => {
    // sign up
    try {
      if (!this.checkForm()) {
        return;
      }

      this.setState({
        disabled: true,
        loading: true
      });

      axios.put(`${AuthService.getApiUrls().site}/campaign/${this.state.campaign.id}`, this.state.campaign).then(() => {
        this.props.openSnackbar('Successfully updated campaign')
        this.props.onClose();
      }).catch(() => {
        this.setState({ disabled: false, loading: false, message: { message: 'Error updating campaign', messageType: MessageTypes.error } });
      });


    } catch (error) {
      this.setState({ disabled: false });
      this.setState({ message: { message: 'Error updating campaign', messageType: MessageTypes.error } });
    }
  }

  handleCampaignChange = (name: string, value: string) => {
    if (name === 'name') {
      this.setState({ 
        campaign: {...this.state.campaign, name: value },
        message: { message: '', messageType: MessageTypes.notification }
      });
    }
    if (name === 'type') {
      this.setState({ 
        campaign: {...this.state.campaign, type: value },
        message: { message: '', messageType: MessageTypes.notification }
      });
    }
    if (name === 'client') {
      this.setState({ 
        campaign: {...this.state.campaign, client: value },
        message: { message: '', messageType: MessageTypes.notification }
      });
    }
    if (name === 'status') {
      this.setState({ 
        campaign: {...this.state.campaign, status: value },
        message: { message: '', messageType: MessageTypes.notification }
      });
    }
  }

  checkForm = () => {
    let error = '';
    if (!this.state.campaign.name) {
      error = 'Name required';
    }
    if (!this.state.campaign.type) {
      error = 'Type required';
    }
    if (!this.state.campaign.client) {
      error = 'Client required';
    }
    if (!this.state.campaign.status) {
      error = 'Status required';
    }
    if (error) {
      this.setState({ message: { message: error, messageType: MessageTypes.error } });
      return false;
    }
    return true;
  }

  render() {
    return (
      <Modal
        open={this.props.open}
        title="Edit Campaign"
        onClose={this.props.onClose}
        message={this.state.message}
      >
        <Loader open={this.state.loading}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <AddCampaign
                name={this.state.campaign.name}
                type={this.state.campaign.type}
                client={this.state.campaign.client}
                showClients
                onChange={this.handleCampaignChange}
              />
            </Grid>
            <Grid item xs={12}>
              <SelectInput
                title="Campaign Status"
                value={this.state.campaign.status}
                values={this.state.statuses}
                onChange={(event: any) => this.handleCampaignChange('status', event.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <ActionButton name="Update" onClick={this.handleSave} fullWidth size="sm" disabled={this.state.disabled} />
            </Grid>
          </Grid>
        </Loader>
      </Modal>
    )
  }

}

const mapStateToProps = (state: any) => {
  return {
    auth: state.auth.auth
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators({ openSnackbar, closeSnackbar }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter<any, any>(EditCampaign));



// WEBPACK FOOTER //
// ./src/pages/admin/campaign/components/EditCampaign.tsx